export function parseQuantity(line) {
  const pattern = /^\s*(\d+(?:[.,]\d+)?|\d+\/\d+)\s*([a-zA-ZåäöÅÄÖ]+)?\s*(.*)$/;
  const match = line.match(pattern);

  if (!match) {
    return {
      amount: null,
      unit: null,
      ingredient: line.trim()
    };
  }

  let amount = null;

  if (match[1]) {
    if (match[1].includes("/")) {
      const [a, b] = match[1].split("/");
      amount = parseFloat(a) / parseFloat(b);
    } else {
      amount = parseFloat(match[1].replace(",", "."));
    }
  }

  const unit = match[2]?.toLowerCase() || null;
  const ingredient = match[3]?.trim() || null;

  return { amount, unit, ingredient };
}
